<ng-template cdkPortal #actions="cdkPortal">
  <button class="btn btn-icon btn-secondary"
          (click)="addPurchase()">
    <icon-plus></icon-plus>
    <span class="ml-2">Add purchase</span>
  </button>
</ng-template>
<smart-table [headers]="headers"
             (filtersChange)="onSearch($event)"
             (sortChange)="onSort($event)"
             [source]="source">
  <ng-template smartTableColumn="id" let-item>
    <td>
      {{ item.id }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="createdAt" let-item>
    <td>
      {{ item.createdAt | moment }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="updatedAt" let-item>
    <td>
      {{ item.updatedAt | moment }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="users" let-item>
    <td>
      <div [class.mb-1]="!last" *ngFor="let user of item?.users; let last = last">
        <entity-link type="user"
                     [item]="user"
                     [name]="user.id"
                     [showInfo]="false"
                     [relativePath]="userData == user.id ? false : relativePath">
        </entity-link>
      </div>
    </td>
  </ng-template>

  <ng-template smartTableColumn="store" let-item>
    <td>
      <entity-link *ngIf="item.parentStore" type="store" [item]="item.parentStore" [name]="item.parentStore.name" [showInfo]="false" [relativePath]="relativePath"></entity-link>
    </td>
  </ng-template>

  <ng-template smartTableColumn="price" let-item>
    <td>
      {{ item.price | numeral: 'currency' }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="currency" let-item>
    <td>
      {{ item.currency }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="market" let-item>
    <td>
      <div class="d-flex align-items-center">
        <ng-container [ngSwitch]="item.market?.name">
          <icon-apple class="text-muted mb-1 mr-2" [style.width.px]="12" *ngSwitchCase="'apple'"></icon-apple>
          <icon-android class="text-muted mr-2" [style.width.px]="12" *ngSwitchCase="'google'"></icon-android>
        </ng-container>
        {{ item.market?.name }}
      </div>
    </td>
  </ng-template>

  <ng-template smartTableColumn="product" let-item>
    <td>
      <entity-link [showInfo]="false" type="product" [item]="item.product" [strong]="true" [relativePath]="relativePath"></entity-link>
    </td>
  </ng-template>

  <ng-template smartTableColumn="expiredAt" let-item>
    <td>
      <ng-container *ngIf="item.expiredAt">
        {{ item.expiredAt | moment }}
      </ng-container>
    </td>
  </ng-template>

  <ng-template smartTableColumn="receipt" let-item>
    <td>
      <div *ngIf="item?.receipts?.length === 1">
        <a class="border-dotted cursor-pointer" (click)="showReceipt(item?.receipts[0].id)">
          ID {{ item?.receipts[0].id }}
        </a>
      </div>
      <div *ngIf="item?.receipts?.length > 1">
        <button type="button" class="btn-link" (click)="showAllReceipts(item)">
          {{ item?.receipts?.length }} items
        </button>
      </div>
    </td>
  </ng-template>

  <ng-template smartTableColumn="force" let-item>
    <td>
      <badge-exist existText="Force" class="mb-2" [item]="item.force"></badge-exist><br>
      <ng-container *ngIf="item.action">
        <small class="text-muted">By action</small> {{ item.action?.key }} <br>
      </ng-container>
      <ng-container *ngIf="item.innerPurchase">
        <small class="text-muted">By user</small><br>
      </ng-container>
      <ng-container *ngIf="item.comment">
        <small class="text-muted">{{ item.comment }}</small>
      </ng-container>
    </td>
  </ng-template>

  <ng-template smartTableColumn="validated" let-item>
    <td>
      <badge-exist existText="Validated" existColor="success" [item]="item.validated"></badge-exist>
    </td>
  </ng-template>

  <ng-template smartTableColumn="checked" let-item>
    <td>
      <badge-exist existText="Checked" existColor="success" [item]="item.checked"></badge-exist>
    </td>
  </ng-template>

  <ng-template smartTableColumn="sandBox" let-item>
    <td>
      <badge-exist existText="SandBox" [item]="item.sandBox"></badge-exist>
    </td>
  </ng-template>


  <ng-template smartTableColumn="failed" let-item>
    <td>
      <badge-exist existText="Failed" existColor="danger" [item]="item.failed"></badge-exist>
    </td>
  </ng-template>

  <ng-template smartTableColumn="innerPurchase" let-item>
    <td>
      <badge-exist existText="Inner" [item]="item.innerPurchase"></badge-exist>
    </td>
  </ng-template>

  <ng-template smartTableColumn="productType" let-item>
    <td>
      {{ item.productType | upperFirst }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="originalTransactionId" let-item>
    <td>
      {{ item.originalTransactionId }}
    </td>
  </ng-template>


  <ng-template smartTableColumn="actions" let-item>
    <td>
      <button class="btn btn-danger btn-sm" type="button" (click)="confirmFail(item)">fail</button>
    </td>
  </ng-template>



  <ng-template smartTableColumn="subject" let-item>
    <td>
      <ng-container *ngIf="item.productType === ProductType.NonConsumable && item.project">
        Project:<br> {{ item.project.name }} <br>
        <small class="text-muted">ID {{ item.project.id }}</small>
      </ng-container>
      <ng-container *ngIf="item.productType === ProductType.NonConsumable && item.storeCollection">
        Collection:<br> {{ item.storeCollection.name }} <br>
        <small class="text-muted">ID {{ item.storeCollection.id }}</small>
      </ng-container>
<!--      <ng-container *ngIf="item.productType === ProductType.Subscription">-->
<!--        <ng-container *ngIf="item.product">-->
<!--          Period: {{ item.product?.subscriptionPeriod }} <br>-->
<!--        </ng-container>-->
<!--      </ng-container>-->
      <ng-container *ngIf="item.productType === ProductType.Consumable">
        Coins:<br> {{ item.product?.coinsValue || item.coinsValue }}
      </ng-container>
    </td>
  </ng-template>

  <ng-template smartTableColumn="json" let-item>
    <td>
      <span class=" border-dotted cursor-pointer" (click)="toggleJson(item)">toggle JSON</span><br>
      <span class="" *ngIf="item.jsonLoading">loading...</span>
      <ngx-json-viewer *ngIf="item.show" [json]="getJson(item.lastResponseFromProvider)" [expanded]="true"></ngx-json-viewer>
    </td>
  </ng-template>
</smart-table>

<pagination [itemsOnPage]="pagination.limit"
            [page]="pagination.currentPage"
            (pageChanged)="setPage($event)"
            [itemsFull]="pagination.fullCount"></pagination>

<preloader [hidden]="!loaderService.isLoading"></preloader>

